"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _time = require('shared/services/time');



const myMetadata = (b, myUserKey) =>
  _optionalChain([b, 'access', _ => _.UserMetadata, 'optionalAccess', _2 => _2[myUserKey]]) 

 const isMarkedUnreadByMe = (b, myUserKey) =>
  !!_optionalChain([myMetadata, 'call', _3 => _3(b, myUserKey), 'optionalAccess', _4 => _4.MarkedUnread]); exports.isMarkedUnreadByMe = isMarkedUnreadByMe

// The one "unread to me" rule, shared by the row, the Unread filter and the
// alert dot, and the server's Unread filter: I marked the chat unread, or it
// moved after I last saw it, or I've never seen it.
 const isUnreadForMe = (b, myUserKey) => {
  const mine = myMetadata(b, myUserKey)
  if (_optionalChain([mine, 'optionalAccess', _5 => _5.MarkedUnread])) return true
  const seenTime = _optionalChain([mine, 'optionalAccess', _6 => _6.SeenTime])
  return !seenTime || +new Date(b.InboxSortTime) > +new Date(seenTime)
}; exports.isUnreadForMe = isUnreadForMe

// The seen time to send when a chat opens, or null to send nothing. Opening
// reads through readThrough when that is newer; a chat marked unread with
// nothing newer still has to be marked seen, at its own seen time, so the
// mark clears without moving what coworkers see in "Seen by".
 const seenTimeOnOpen = (
  readThrough,
  seenTime,
  markedUnread,
) => {
  if (readThrough && (!seenTime || _time.isLaterTime.call(void 0, readThrough, seenTime))) return readThrough
  if (markedUnread) return seenTime || readThrough || null
  return null
}; exports.seenTimeOnOpen = seenTimeOnOpen
